import Query from "@arcgis/core/rest/support/Query";
import Point from "@arcgis/core/geometry/Point";
import { executeQueryJSON } from "@arcgis/core/rest/query";
import { Address, addressToString } from "../model/address";
import { locationAuthApi } from "./LocationAuthApi";

/*
 * Interfaces with ArcGIS service
 */
class LocationApi {

  public constructor() {
    this.validateAddress = this.validateAddress.bind(this);
    this.geoCode = this.geoCode.bind(this);
  }
  
  /**
   * Validate whether the given address is in Springboro City
   * @param address Address to validate
   * @returns Query result from query task or rejects promise
   */
  public async validateAddress(address: Address): Promise<boolean> {
    const tokenObj = await locationAuthApi.getAccessToken();
    const accessToken = tokenObj.data.token;

    const whitelist = tokenObj.data.whitelisted_addresses;
    let structured_address = 
      `${address.address_1}${address.city}${address.zip}`
      .replace(/\s/g,'')
      .toLowerCase()
    
    const isWhitelisted = whitelist.includes(structured_address);

    if (isWhitelisted) {
      return true;
    }
    
    const locationObj = await this.geoCode(addressToString(address), accessToken);
    // Select location with a 97% match or higher to allow wiggle room if user didn't add 'dr'. 'ave', etc
    const locationResponse: any = locationObj.candidates.find((l: any) => l.score >= 97);

    if (!locationResponse) {
      throw new Error('Invalid location. Please edit location fields and try again.');
    }

    const { location } = locationResponse;
    const query = new Query({
      returnGeometry: true,
      geometry: new Point({
        ...location,
      }),
      spatialRelationship: "intersects",
    });
    const queryUrl = `${import.meta.env.VITE_APP_ARCGIS_FEATURE_LAYER_URL}?token=${accessToken}`;
    const result = await executeQueryJSON(queryUrl, query);
    return result.features.length > 0;
  }

  /**
   * Convert given address to x, y coordinates
   * @returns location object
   */
  private async geoCode(address: string, accessToken: string) {
    const response = await fetch(
      `https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?f=pjson&singleLine=${address}&token=${accessToken}`
    );
    return response.json();
  }

}
export const locationApi = new LocationApi();
